const STORAGE_KEY = "pixyquiz_active_game";

export function saveActiveGame(slug, categoryName) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ slug, categoryName }));
  window.dispatchEvent(new CustomEvent("pixyquiz:game-start"));
}

export function clearActiveGame() {
  sessionStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent("pixyquiz:game-end"));
}

export function getActiveGame() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
